import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Link from 'gatsby-link';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class Menu extends Component {
  render() {
    const { t, user } = this.props;
    console.log('render menu');
    if (user == null) {
      return null;
    } else {
      let adminLink;
      if (user.role === 'ADMIN') {
        adminLink = (
          <li className="nav-item">
            <Link className="nav-link" to="/admin">
              Administration
            </Link>
          </li>
        );
      }
      return (
        <nav className="nav">
          <ul className="nav flex-column">
            {adminLink}
            <li className="nav-item dropdown">
              <Link
                to="/dissertoSuite"
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {t('downloadTitle')}
              </Link>
              <div className="dropdown-menu">
                <Link className="dropdown-item" to="/downloadInformation">
                  {t('general')}
                </Link>
                <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/downloadDissertoSuite">
                  {t('disserto')}
                </Link>
                <Link className="dropdown-item" to="/downloadAs">
                  {t('AS')}
                </Link>
                <Link className="dropdown-item" to="/downloadDas">
                  {t('DAS')}
                </Link>
                <Link className="dropdown-item" to="/downloadDcg">
                  {t('DCG')}
                </Link>
                <Link className="dropdown-item" to="/downloadDds">
                  {t('DDS')}
                </Link>
                <Link className="dropdown-item" to="/downloadLic">
                  {t('LIC')}
                </Link>
                <Link className="dropdown-item" to="/downloadMp">
                  {t('MP')}
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown">
              <Link
                to="/dissertoSuite"
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {t('productTitle')}
              </Link>
              <div className="dropdown-menu">
                <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/description">
                  {t('description')}
                </Link>
                <Link className="dropdown-item" to="/version">
                  {t('version')}
                </Link>
              </div>
            </li>
            <li className="nav-item dropdown">
              <Link
                to="/dissertoSuite"
                className="nav-link dropdown-toggle"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {t('supportTitle')}
              </Link>
              <div className="dropdown-menu">
                <Link className="dropdown-item" to="/support">
                  {t('report')}
                </Link>
                <Link className="dropdown-item" to="/licenseRequest">
                  {t('licenseKey')}
                </Link>
                <Link className="dropdown-item" to="/documentation">
                  {t('userDoc')}
                </Link>
                <Link className="dropdown-item" to="/userLicenses">
                  {t('userLicenses')}
                </Link>
              </div>
            </li>
          </ul>
        </nav>
      );
    }
  }
}
function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user,
  };
}

Menu.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default connect(mapStateToProps)(translate('Menu')(Menu));



// WEBPACK FOOTER //
// ./src/components/Menu/index.js